export default "__VITE_ASSET__CtCdBDrq__";